export default __webpack_public_path__ + "static/media/amandag2.2407af93.jpg";